import { Headline } from 'components/Headline';

export const Forbidden = () => (
  <>
    <Headline scale="xl3">Access Denied</Headline>
    <Headline>
      You don't have the necessary permissions to see this page, please contact an
      administrator to request them.
    </Headline>
  </>
);
